function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1102",
  "data-name": "Group 1102",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-user-alt",
  "data-name": "Icon awesome-user-alt",
  d: "M21.831,24.559A12.28,12.28,0,1,0,9.551,12.28,12.283,12.283,0,0,0,21.831,24.559Zm10.915,2.729h-4.7a14.844,14.844,0,0,1-12.433,0h-4.7A10.914,10.914,0,0,0,0,38.2v1.364a4.094,4.094,0,0,0,4.093,4.093H39.568a4.094,4.094,0,0,0,4.093-4.093V38.2A10.914,10.914,0,0,0,32.746,27.288Z",
  transform: "translate(18.516 28.068)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-star",
  "data-name": "Icon ionic-ios-star",
  d: "M25.877,11.269H17.813l-2.45-7.313a.888.888,0,0,0-1.667,0l-2.45,7.313H3.127a.88.88,0,0,0-.877.877.645.645,0,0,0,.016.148.843.843,0,0,0,.367.619l6.628,4.671-2.544,7.4a.88.88,0,0,0,.3.987.848.848,0,0,0,.493.214,1.075,1.075,0,0,0,.548-.2l6.469-4.61L21,25.983a1.027,1.027,0,0,0,.548.2.788.788,0,0,0,.488-.214.869.869,0,0,0,.3-.987l-2.544-7.4,6.573-4.715.159-.137a.92.92,0,0,0,.285-.587A.928.928,0,0,0,25.877,11.269Z",
  transform: "translate(53.691 20.795)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-star-2",
  "data-name": "Icon ionic-ios-star",
  d: "M25.877,11.269H17.813l-2.45-7.313a.888.888,0,0,0-1.667,0l-2.45,7.313H3.127a.88.88,0,0,0-.877.877.645.645,0,0,0,.016.148.843.843,0,0,0,.367.619l6.628,4.671-2.544,7.4a.88.88,0,0,0,.3.987.848.848,0,0,0,.493.214,1.075,1.075,0,0,0,.548-.2l6.469-4.61L21,25.983a1.027,1.027,0,0,0,.548.2.788.788,0,0,0,.488-.214.869.869,0,0,0,.3-.987l-2.544-7.4,6.573-4.715.159-.137a.92.92,0,0,0,.285-.587A.928.928,0,0,0,25.877,11.269Z",
  transform: "translate(25.816 -3.375)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-star-3",
  "data-name": "Icon ionic-ios-star",
  d: "M25.877,11.269H17.813l-2.45-7.313a.888.888,0,0,0-1.667,0l-2.45,7.313H3.127a.88.88,0,0,0-.877.877.645.645,0,0,0,.016.148.843.843,0,0,0,.367.619l6.628,4.671-2.544,7.4a.88.88,0,0,0,.3.987.848.848,0,0,0,.493.214,1.075,1.075,0,0,0,.548-.2l6.469-4.61L21,25.983a1.027,1.027,0,0,0,.548.2.788.788,0,0,0,.488-.214.869.869,0,0,0,.3-.987l-2.544-7.4,6.573-4.715.159-.137a.92.92,0,0,0,.285-.587A.928.928,0,0,0,25.877,11.269Z",
  transform: "translate(-2.25 20.795)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}));

function SvgQualified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.501,
    height: 72.729,
    viewBox: "0 0 81.501 72.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualified);
export default __webpack_public_path__ + "static/media/qualified.930e3998edd0946d5c0f4abf8cb926b1.svg";
export { ForwardRef as ReactComponent };